/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseDayOff } from '../../models/api-response-day-off';
import { DayOff } from '../../models/day-off';

export interface UpdateDayOff$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  ref: string;
      body: DayOff
}

export function updateDayOff(http: HttpClient, rootUrl: string, params: UpdateDayOff$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseDayOff>> {
  const rb = new RequestBuilder(rootUrl, updateDayOff.PATH, 'put');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('ref', params.ref, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseDayOff>;
    })
  );
}

updateDayOff.PATH = '/v1/api/ui/dayOff/{ref}';
